<div class="gray-box-container bg-gray-300 flex justify-center items-center w-6/6 p-3 min-h-100 sm:p-8 sm:h-80" style="border-radius: 12px; width: 100%" [class]="walletClass">
  <div class="wallet-method-container-confirmation items-center w-full lg:w justify-center flex flex-row">
    <mat-spinner
      class="loading-spinner"
      [color]="color"
      [diameter]="diameter"
    >
    </mat-spinner>
    <p class="text-pink-600 text-sm sm:text-lg md:text-xl ml-2 mb-0"><strong>WAITING FOR PAYMENT CONFIRMATION...</strong></p>
  </div>
</div>
